import { WabunkaPublishStatus as WabunkaPublishStatusProto } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience';
export const publishStatuses = ['DRAFT', 'PRIVATE', 'PUBLISHED'] as const;
export type WabunkaPublishStatus = (typeof publishStatuses)[number];

export const buildWabunkaPublishStatus = (res: WabunkaPublishStatusProto): WabunkaPublishStatus => {
  switch (+res) {
    case WabunkaPublishStatusProto.STATUS_UNKNOWN:
      throw new Error(`=== PublishStatus: unknown, res: ${res}`);
    case WabunkaPublishStatusProto.DRAFT:
      return 'DRAFT';
    case WabunkaPublishStatusProto.PRIVATE:
      return 'PRIVATE';
    case WabunkaPublishStatusProto.PUBLISHED:
      return 'PUBLISHED';
    default:
      throw new Error(`=== PublishStatus: unknown, res: ${res}`);
  }
};
